module.exports = __webpack_public_path__ + "static/media/roomSpace-blue.7ff3dfcc.svg";